export function formatDate(isoString) {
  const date = new Date(isoString);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
}

export function parseNumberString(str) {
  if (typeof str !== "string") return NaN;
  return parseFloat(str.replace(/,/g, ""));
}
